import QTableColumn from '../table/src/table-column';


export default QTableColumn;
